module.exports = __webpack_public_path__ + "static/media/audit.2d547c4a.jpg";